var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat_alt_2_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0886 11.3513C21.0886 8.00011 21.0886 6.32453 20.2843 5.12089C19.9362 4.59981 19.4888 4.15242 18.9677 3.80425C17.7641 3 16.0885 3 12.7373 3H10.3513C7.00011 3 5.32453 3 4.12089 3.80425C3.59981 4.15242 3.15242 4.59981 2.80425 5.12089C2 6.32453 2 8.00011 2 11.3513C2 14.7024 2 16.378 2.80425 17.5816C3.15242 18.1027 3.59981 18.5501 4.12089 18.8983C5.17237 19.6009 6.584 19.6897 9.15822 19.7009V19.7025L10.4772 22.3405C10.9169 23.2198 12.1717 23.2198 12.6114 22.3405L13.9304 19.7025V19.7009C16.5046 19.6897 17.9162 19.6009 18.9677 18.8983C19.4888 18.5501 19.9362 18.1027 20.2843 17.5816C21.0886 16.378 21.0886 14.7024 21.0886 11.3513ZM7.96519 7.96519C7.4129 7.96519 6.96519 8.4129 6.96519 8.96519C6.96519 9.51747 7.4129 9.96519 7.96519 9.96519H15.1234C15.6757 9.96519 16.1234 9.51747 16.1234 8.96519C16.1234 8.4129 15.6757 7.96519 15.1234 7.96519H7.96519ZM7.96519 12.7373C7.4129 12.7373 6.96519 13.1851 6.96519 13.7373C6.96519 14.2896 7.4129 14.7373 7.96519 14.7373H11.5443C12.0966 14.7373 12.5443 14.2896 12.5443 13.7373C12.5443 13.1851 12.0966 12.7373 11.5443 12.7373H7.96519Z",
    fill: "#A399B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackFill);
export default __webpack_public_path__ + "static/media/Feedback_fill.98ecda2da521d6b69995c5d806589aad.svg";
export { ForwardRef as ReactComponent };